import styled from "@emotion/styled";

export const Container = styled.div`
  position: relative;
`;

export const PlusBlurbOverlay = styled.div`
  position: absolute;
  inset-block: 0;
  inset-inline: 0;
  z-index: 1;

  inline-size: 100%;
  block-size: 100%;
`;
